export default __webpack_public_path__ + "static/media/UK01.1.59885120.mp3";